import { inject, Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Installation } from "src/app/backend/models/installation";
import { Integration } from "src/app/backend/models/integration";
import { CONNECT_INTEGRATION_CONNECTOR_TOKEN_FN } from "src/app/modules/bootstrap/functions/integrations/connect-integration/connect-integration-connector.token";
import {
  ConnectIntegrationConnectionResult,
  ConnectIntegrationConnectionResultType
} from "src/app/modules/bootstrap/functions/integrations/connect-integration/connect-integration.connector";
import { ToastService } from "src/app/services/toast.service";
import { sntTranslate } from "src/app/support/translate";

type Input = {
  integration: Integration;
  installation: Installation;
  isRefresh?: boolean;
  refreshConnectionId?: string;
  phase: "install" | "execute";
};

@Injectable()
export class ConnectIntegrationFunctionService {
  private readonly toastService = inject(ToastService);
  private readonly connectIntegrationConnectorFn = inject(
    CONNECT_INTEGRATION_CONNECTOR_TOKEN_FN
  );

  async execute({
    integration,
    installation,
    isRefresh,
    refreshConnectionId,
    phase
  }: Input): Promise<ConnectIntegrationConnectionResult> {
    const connector = this.connectIntegrationConnectorFn(integration);

    const connectionResult = await connector.connect({
      installation,
      integration,
      isRefresh,
      refreshConnectionId,
      phase
    });

    switch (connectionResult.result) {
      case ConnectIntegrationConnectionResultType.SUCCEED: {
        await this.toastService.success(
          sntTranslate(marker("Connessione a [integrationName] effettuata"), {
            integrationName: integration.name
          })
        );
        break;
      }
      case ConnectIntegrationConnectionResultType.FAILED: {
        await this.toastService.error(
          sntTranslate(marker("Connessione a [integrationName] fallita"), {
            integrationName: integration.name
          })
        );
        break;
      }
      case ConnectIntegrationConnectionResultType.CANCELED: {
        await this.toastService.warning(
          sntTranslate(marker("Connessione a [integrationName] annullata"), {
            integrationName: integration.name
          })
        );
        break;
      }
    }

    return connectionResult;
  }
}
